export default __webpack_public_path__ + "static/media/icon-accept.3a21862c.svg";